import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

const UserState = () => {
    const { isAuthenticated, isLoading } = useAuth0();
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            setData(null);
        }
    }, [isAuthenticated, isLoading]);

    const setUser = (value) => {
        setData(value);
    };

    return [data, setUser];
};

export const UserProvider = ({ children }) => {
    const [user, setUser] = UserState();

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
};
